import { render, staticRenderFns } from "./zbsjk-detail.vue?vue&type=template&id=a68dad56&"
import script from "./zbsjk-detail.vue?vue&type=script&lang=ts&"
export * from "./zbsjk-detail.vue?vue&type=script&lang=ts&"
import style0 from "./zbsjk-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports